import React from 'react';
import usePcrV2 from './usePcrV2';

type Rule = { from: RegExp; to: string };

type Placeholders = {
  typeName: string;
  typeWeight: string;
  typeKgCPerKg: string;
};

export function useContentDeclarationTerminologyHelper() {
  const isPcrV2 = usePcrV2();

  const rules: Rule[] = isPcrV2
    ? [
        { from: /\bWeight\b/g, to: 'Mass' },
        { from: /\bweight\b/g, to: 'mass' },
        { from: /weight-%/g, to: 'mass-%' },
      ]
    : [];

  const replaceInString = (text: string | undefined | null): string | undefined | null => {
    if (typeof text !== 'string' || rules.length === 0) return text;
    return rules.reduce((acc, r) => acc.replace(r.from, r.to), text);
  };

  const replaceInNode = (node: React.ReactNode): React.ReactNode => {
    if (rules.length === 0) return node;
    if (typeof node === 'string') return replaceInString(node) ?? node;
    if (Array.isArray(node)) return node.map(replaceInNode);
    if (React.isValidElement(node)) {
      const el = node as React.ReactElement<{ children?: React.ReactNode }>;
      const newChildren = React.Children.map(el.props.children, replaceInNode);
      return React.cloneElement(el, undefined, newChildren);
    }
    return node; // number | boolean | null | undefined
  };

  const placeholders: Placeholders = isPcrV2
    ? { typeName: 'Type here', typeWeight: 'Type here', typeKgCPerKg: 'Type here' }
    : { typeName: 'Type name', typeWeight: 'Type weight', typeKgCPerKg: 'Type kg C/kg' };

  return { isPcrV2, replaceInString, replaceInNode, placeholders };
}
